import * as React from "react";
import { DefinitionList, Icon, Spinner } from "components/common";
import { DataWell } from "security-app/components/common";
import { Row, Col } from "security-app/components/common/FormBaseStyles";
import { useGetAssetsByIds, useGetPriorities } from "security-app/hooks/useAssetsAPI";
import RiskPriorityHeader from "./RiskPriorityHeader";
const Members = ({ memberIds }) => {
  const { assets, fetchingAssets } = useGetAssetsByIds(memberIds);
  if (memberIds.length === 0) return /* @__PURE__ */ React.createElement("i", null, "No members");
  if (fetchingAssets) return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading members..." });
  const memberNames = memberIds.map((memberId) => {
    var _a, _b;
    return (_b = (_a = assets.find((asset) => asset.id === memberId)) == null ? void 0 : _a.name) != null ? _b : memberId;
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, memberNames.join(", "));
};
function GroupData({ groupAsset }) {
  var _a, _b;
  const { priorities } = useGetPriorities();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Icon, { name: "group" }), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("small", null, "Group ID"), /* @__PURE__ */ React.createElement("span", null, groupAsset.details.group_id || /* @__PURE__ */ React.createElement("i", null, "No group ID"))))), /* @__PURE__ */ React.createElement(
    RiskPriorityHeader,
    {
      riskScore: groupAsset.risk_score_normalized,
      priorityValue: groupAsset.priority,
      priorities
    }
  ), /* @__PURE__ */ React.createElement(DefinitionList, null, /* @__PURE__ */ React.createElement("dt", null, "Categories"), /* @__PURE__ */ React.createElement("dd", null, ((_a = groupAsset.category) == null ? void 0 : _a.join(", ")) || /* @__PURE__ */ React.createElement("i", null, "Uncategorized")), /* @__PURE__ */ React.createElement("dt", null, "Type"), /* @__PURE__ */ React.createElement("dd", null, groupAsset.details.type), /* @__PURE__ */ React.createElement("dt", null, "Members"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(Members, { memberIds: (_b = groupAsset.details.members) != null ? _b : [] }))));
}
export default GroupData;
